import { DialogActions, DialogContent } from "@mui/material";
import api from "app/api";
import {
  Button,
  CreatedUpdatedBy,
  Field,
  FieldsContainer,
  File,
  Form,
  GridModalFormProps,
  PageHeader,
  TextField,
  useDownloadUrl,
} from "common";
import { getBookingService } from "features/bookings/bookingApi";
import I18n from "i18n";
import { BookingDocumentType } from "./bookingDocumentApi";
import useBookingDocumentForm from "./useBookingDocumentForm";

export interface BookingDocumentFormProps extends GridModalFormProps {
  type?: BookingDocumentType;
}

export default function BookingDocumentForm({
  id,
  afterSave,
  onClose,
  defaultValues,
  type,
}: BookingDocumentFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
    params,
  } = useBookingDocumentForm({ id, afterSave, defaultValues, type });

  const { downloadUrl } = useDownloadUrl();
  const uploadService = api.getService("files");
  const bookingService = getBookingService();

  const title = isCreate
    ? I18n.t("BookingDocument.addTitle")
    : I18n.t("BookingDocument.editTitle");

  return (
    <>
      <PageHeader title={title} onClose={onClose} loading={loading} />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="BookingDocument.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
        >
          <FieldsContainer>
            {/*!params.booking_id && (
              <Field fullWidth>
                <Autocomplete
                  id="booking_id"
                  loadItems={bookingService.loadAutocomplete}
                />
              </Field>
            )*/}
            <Field fullWidth>
              <TextField id="name" />
            </Field>
            <Field fullWidth>
              <TextField id="description" multiline rows={4} />
            </Field>
            <Field fullWidth>
              <File
                id="file_id"
                uri={downloadUrl(item.file_id)}
                upload={uploadService.uploadFile}
                file={(item as any).file}
              />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <CreatedUpdatedBy item={item} />
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
          color="primary"
          variant="contained"
        />
      </DialogActions>
    </>
  );
}
